// console.log(`js/01-pageSections/billboard.js is working`);

const billboardHeader = document.querySelector(`.header`);

if (billboardHeader) {
  const billboardTransition = () => {
    let modal = document.querySelector(`.special-offer-modal.hidden`);
    let quote = document.querySelector(`.inspirational-statement.hidden`);
    modal.classList.remove(`hidden`);
    quote.classList.remove(`hidden`);
  };

  let billboardSection = document.querySelector(`.billboard`);

  if (billboardSection) {
    window.addEventListener(`load`, billboardTransition);
  }

  // Billboard Background Video Playback Controls
  const videoToggle = document.getElementById(`toggle`);
  if (videoToggle) {
    const media = document.getElementById(`background-video`);
    const toggle = document.getElementById(`toggle`);
    const videoControls = () => {
      if (media.paused) {
        toggle.innerHTML = `<i class="fas fa-pause"></i> Pause Video`;
        toggle.classList.remove(`paused`);
        toggle.classList.add(`playing`);
        media.play();
      } else {
        toggle.innerHTML = `<i class="fas fa-play"></i> Play Video`;
        toggle.classList.remove(`playing`);
        toggle.classList.add(`paused`);
        media.pause();
      }
    };
    toggle.addEventListener(`click`, videoControls);
  }
}

/**
 * Controls the billboard and site-header z-index when a modal is present
 */

const modalExists = document.querySelector(`.billboard-modal`);

if (modalExists) {
  const stickyForm = document.querySelector(`.sticky-form`);

  const switchZIndexes = () => {
    console.log(`open click worked`);
    stickyForm.style.zIndex = `1`;
  };

  const removeZIndexes = () => {
    console.log(`close click worked`);
    stickyForm.style.removeProperty(`z-index`);
  };

  const billboardModalOpen = document.querySelector(`.billboard-button`);
  billboardModalOpen.addEventListener(`click`, switchZIndexes);

  const billboardModalClose = document.querySelector(`.billboard-modal .close`);
  billboardModalClose.addEventListener(`click`, removeZIndexes);
}
